export class LoadPlanogramStateRequest{
    planogramId : string = '';
    stateId : string = '';
    constructor(planogramId: string, stateId: string){
        this.planogramId = planogramId;
        this.stateId = stateId;
    }
}

